export const ACCEPTING_CLIENTS = false;
export const DISABLE_CONTACT = true;
export const API_URL = "https://mailer.jarv.dev"
export const CONTACT_URL = `${API_URL}/send/ptg/`;
